const getApiHistory = async (csrfToken, clientId) => {
  const body = { clientId };
  try {
    const apiResponse = await fetch('/studio/api/v1/apis/calls', {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    return await apiResponse.json();
  } catch {
    return { items: [] };
  }
};

const fetchTestAccounts = async (csrfToken, clientId) => {
  const body = { clientId };
  try {
    const apiResponse = await fetch(`/studio/api/v1/customer/testaccounts`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });
    if (apiResponse.status !== 200) {
      throw new Error(`Error getting test acccounts.`);
    }
    return await apiResponse.json();
  } catch (error) {
    return { error, accounts: [] };
  }
};

const fetchTestAccountDetails = async (csrfToken, clientId, accountId) => {
  const body = { clientId, accountId };
  try {
    const apiResponse = await fetch(`/studio/api/v1/customer/testaccounts/details`, {
      method: 'POST',
      headers: {
        'X-CSRF-Token': csrfToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(body)
    });

    if (apiResponse.status !== 200) {
      throw new Error(`Error getting test acccount details.`);
    }

    return await apiResponse.json();
  } catch (error) {
    return { error, details: {} };
  }
};

export { getApiHistory, fetchTestAccounts, fetchTestAccountDetails };
